export function dropdowns() {
    let body = $("body");
    let mainBlock = $(".main");
    let menuItemsWithDropDowns = body.find(".has-dropdown");
    let openedDropdownClass = "active";
    let eventType = "mouseenter";
    let closeDropdownButton = $(".dropdown-body > .close-button");
    let selector = "> .dropdown-head-title";

    if (body.hasClass("touch")) {
        eventType = "click";
    }

    if (closeDropdownButton.length) {
        closeDropdownButton.on("click", function () {
            $(this).closest(".has-dropdown").removeClass(openedDropdownClass);
        });
    }

    menuItemsWithDropDowns.on(eventType, selector, function (e) {
        if (!$(this).find(".link") && $(window).width() < 1200) {
            e.preventDefault();
        }

        let curMenuItemHasDropdown = $(this).closest(".has-dropdown");

        $.each(menuItemsWithDropDowns, function () {
            let menuItemsWithDropDown = $(this);

            menuItemsWithDropDown[(menuItemsWithDropDown.is(curMenuItemHasDropdown) ? "toggle" : "remove") + "Class"](openedDropdownClass);

            if (!menuItemsWithDropDown.closest(".language-dropdown")) {
                mainBlock.addClass("lock");
            }
        });
    });

    menuItemsWithDropDowns.on("mouseleave", function (e) {
        $.each(menuItemsWithDropDowns, function () {
            let menuItemsWithDropDown = $(this);

            if (menuItemsWithDropDown.hasClass(openedDropdownClass)) {
                menuItemsWithDropDown.removeClass(openedDropdownClass);
            }
            mainBlock.removeClass("lock");
        });
    });

    body.mouseup(function (e){
        var menuItem = $(".has-dropdown");

        if (!menuItem.is(e.target)
            && menuItem.has(e.target).length === 0
            && menuItem.hasClass(openedDropdownClass)) {

            menuItem.removeClass(openedDropdownClass);
            mainBlock.removeClass("lock");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/dropdowns.js